import React from "react";
import LinkList from "../../Pages/LinkList";

const ReturnPolicy = () => {
  return (
    <>
      <LinkList />
      <div className="py-5">
        <div className="container">
          <h5 className="fs_24 fw-bold ff_helvetica">RETURN POLICY</h5>
          <p className="fs_15 ff_inter color_darkgray_4 mt-4">
            At Drone Planet, we strive to provide the highest quality drone parts and accessories. If you are not entirely satisfied with your purchase, we're here to help facilitate a return or exchange according to the terms outlined below.
          </p>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">1. Eligibility for Returns</h6>
          <p className="fs_15 ff_inter color_darkgray_4 mt-3">
            To be eligible for return, please ensure that:
          </p>
          <ul className="fs_15 ff_inter color_darkgray_4 mt-3">
            <li>The Items must be returned within 5-7 days from the delivery date.</li>
            <li>The Items must be unused, undamaged and in its original condition in which and in the original packaging. This includes all protective films, tags, manuals, accessories, and components.</li>
            <li>A receipt, invoice, or proof of purchase is required for all returns.</li>
          </ul>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">2. Non-Returnable Items</h6>
          <p className="fs_15 ff_inter color_darkgray_4 mt-3">
            The following items are not eligible for return:
          </p>
          <ul className="fs_15 ff_inter color_darkgray_4 mt-3">
            <li>Custom-built or special-order drones</li>
            <li>Items purchased on clearance or discount</li>
            <li>Software or downloadable content</li>
            <li>Opened or used drone batteries due to safety concerns</li>
          </ul>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">3. Return Process</h6>
          <p className="fs_15 ff_inter color_darkgray_4 mt-3">
            To initiate a return:
          </p>
          <ul className="fs_15 ff_inter color_darkgray_4 mt-3">
            <li><strong>Contact Us:</strong> Contact our customer support team at support@droneplanet.in with your order number and reason for the return.</li>
            <li><strong>Return Authorisation:</strong> Once your return request is approved, you will receive a Return Merchandise Authorisation (RMA) number and return instructions.</li>
            <li><strong>Ship the Item:</strong> Pack the item securely and include your RMA number. Ship the item to the address provided in the return instructions.</li>
          </ul>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">4. Inspection and Approval</h6>
          <p className="fs_15 ff_inter color_darkgray_4 mt-3">
            Upon receiving the returned item, we will inspect it to ensure it meets the eligibility conditions within 5-7 business days outlined in this policy. We will notify the customer via email regarding the status of the return and whether the refund or exchange has been approved or rejected based on the inspection.
          </p>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">5. Refunds</h6>
          <p className="fs_15 ff_inter color_darkgray_4 mt-3">
            If the return is approved, a refund will be processed to the original method of payment.
          </p>
          <ul className="fs_15 ff_inter color_darkgray_4 mt-3">
            <li>Refunds are issued to the original payment method.</li>
            <li>Shipping costs are non-refundable.</li>
            <li>Once approved, refunds will be credited within 7-10 business days after we receive and inspect the returned item. Please remember it takes time for your bank or credit card company to process and post the refund to the customer's account.</li>
          </ul>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">6. How Refunds Are Issued</h6>
          <p className="fs_15 ff_inter color_darkgray_4 mt-3">
            Payment Method Refund Timeline
          </p>
          <ul className="fs_15 ff_inter color_darkgray_4 mt-3">
            <li><strong>Credit/Debit Card:</strong> 7-10 business days</li>
            <li><strong>UPI/Net Banking:</strong> 7-10 business days</li>
            <li><strong>Wallets (Paytm, PhonePe, etc.):</strong> 7-10 business days</li>
          </ul>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">7. Replacements and Exchanges</h6>
          <ul className="fs_15 ff_inter color_darkgray_4 mt-3">
            <li>We offer replacements for items that are defective, damaged, or incorrect at the time of delivery.</li>
            <li>Once the replacement is confirmed, the replacement items will be delivered within 10-21 days.</li>
            <li>To request a replacement, contact support@droneplanet.in with your order number and evidence of the issue (e.g., photos or video).</li>
            <li>Replacements are subject to stock availability. If a replacement is unavailable, a refund will be issued.</li>
          </ul>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">8. Shipping Costs for Returns</h6>
          <ul className="fs_15 ff_inter color_darkgray_4 mt-3">
            <li>You will be responsible for paying for your own shipping costs for returning your item.</li>
            <li>If you receive a refund, the cost of return shipping will be deducted from your refund unless the return is due to a defective or incorrect item supplied by us.</li>
            <li>For defective or damaged items, we will cover the return shipping costs.</li>
          </ul>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">9. Damages and Issues</h6>
          <p className="fs_15 ff_inter color_darkgray_4 mt-3">
            Please inspect your order upon reception and contact us immediately within 48 hours if the item is defective, damaged or if you receive the wrong item, so that we can evaluate the issue and make it right.
          </p>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">10. Order Cancellations</h6>
          <p className="fs_15 ff_inter color_darkgray_4 mt-3">
            If you wish to cancel an order, please contact us as soon as possible after placing the order. We may be able to cancel your order if it has not yet been processed or shipped. If the order has already been processed or shipped, it will be subject to our standard return policy.
          </p>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">11. Contact Us</h6>
          <p className="fs_15 ff_inter color_darkgray_4 mt-3">
            If you have any questions about our refund and return policy, please contact us at:
          </p>
          <ul className="fs_15 ff_inter color_darkgray_4 mt-3">
            <li><strong>Email:</strong> support@droneplanet.in</li>
            <li><strong>Phone:</strong> +91 9773571992</li>
          </ul>

          <h6 className="ff_helvetica fs_18 fw-bold mt-4">12. Policy Changes</h6>
          <ul className="fs_15 ff_inter color_darkgray_4 mt-3">
            <li>We reserve the right to update or modify this policy at any time. Changes will be posted on this page, and the policy's effective date will be updated accordingly.</li>
            <li>Customers are advised to review this policy periodically. Continued use of our services after any changes constitutes acceptance of the revised policy.</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default ReturnPolicy;